// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fb930e30","833":"3b503886"}[chunkId] + ".chunk.js";
};